export const apexColors = ['#4b5563', '#22c55e'];